import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';

interface SafeHtmlWithScriptsProps {
  htmlContent: string;
  className?: string;
  style?: React.CSSProperties;
}

const SafeHtmlWithScripts: React.FC<SafeHtmlWithScriptsProps> = ({
  htmlContent,
  className,
  style,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create a temporary div to parse HTML content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Filter out script tags and append the rest to the container
    const elements = Array.from(tempDiv.childNodes).filter(
      (node) => node.nodeName.toLowerCase() !== 'script',
    );
    containerRef.current.innerHTML = '';
    elements.forEach((el) => {
      containerRef.current?.appendChild(el);
    });

    // Handle script tags separately
    const scripts = tempDiv.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const oldScript = scripts[i];
      const newScript = document.createElement('script');
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }
      if (oldScript.innerHTML) {
        newScript.text = oldScript.innerHTML;
      }
      containerRef.current.appendChild(newScript);
    }
  }, [htmlContent]);

  return (
    <div
      ref={containerRef}
      className={clsx('html-block-direct', className)}
      style={style}
    />
  );
};

export default SafeHtmlWithScripts;
